export const APP_CONST = {
    PER_PAGE: 10,
    PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
  };

export const MONTHS_LIST = [
    'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August',
    'September', 'October', 'November', 'December'
  ];

export const GENDER = ['MALE', 'FEMALE', 'OTHERS'];

export const LANGUAGES = [
  'en-IN', // English (India)
  'en-US', // English (United States)
  'fr-FR', // French (France)
  'de-DE', // German (Germany)
  'it-IT', // Italian (Italy)
  'es-ES', // Spanish (Spain)
  'pt-PT', // Portuguese (Portugal)
  'zh-CN', // Chinese (China)
  'ar-SA', // Arabic (Saudi Arabia)
  'ja-JP', // Japanese (Japan)
  'ko-KR', // Korean (South Korea)
  'ru-RU', // Russian (Russia)
  'hi-IN', // Hindi (India)
  'bn-IN', // Bengali (India)
  'ta-IN', // Tamil (India)
  'fr-CA', // French (Canada)
  'sw-KE', // Swahili (Kenya)
  'pl-PL', // Polish (Poland)
  'nl-NL', // Dutch (Netherlands)
  'sv-SE', // Swedish (Sweden)
  'fi-FI', // Finnish (Finland)
  'da-DK', // Danish (Denmark)
  'no-NO', // Norwegian (Norway)
  'tr-TR', // Turkish (Turkey)
  'fa-IR', // Persian (Iran)
  'he-IL', // Hebrew (Israel)
  'th-TH', // Thai (Thailand)
  'vi-VN', // Vietnamese (Vietnam)
  'uk-UA', // Ukrainian (Ukraine)
  'cs-CZ', // Czech (Czech Republic)
  'ro-RO', // Romanian (Romania)
  'el-GR', // Greek (Greece)
  'hr-HR', // Croatian (Croatia)
  'mk-MK', // Macedonian (Macedonia)
  'lt-LT', // Lithuanian (Lithuania)
  'et-EE', // Estonian (Estonia)
  'sq-AL', // Albanian (Albania)
  'ms-MY', // Malay (Malaysia)
  'tl-PH', // Filipino (Philippines)
  'ne-NP', // Nepali (Nepal)
  'am-ET', // Amharic (Ethiopia)
  'sn-ZW', // Shona (Zimbabwe)
  'zu-ZA', // Zulu (South Africa)
  'pa-IN', // Punjabi (India)
  'mr-IN', // Marathi (India)
  'gu-IN', // Gujarati (India)
  'ml-IN', // Malayalam (India)
  'or-IN', // Odia (India)
  'as-IN', // Assamese (India)
  'kn-IN', // Kannada (India)
  'si-LK', // Sinhala (Sri Lanka)
  'my-MM', // Burmese (Myanmar)
  'km-KH', // Khmer (Cambodia)
  'lo-LA', // Lao (Laos)
  'sr-RS', // Serbian (Serbia)
  'bs-BA', // Bosnian (Bosnia and Herzegovina)
  'ca-ES', // Catalan (Spain)
  'is-IS', // Icelandic (Iceland)
  'fi-FI', // Finnish (Finland)
  'mt-MT', // Maltese (Malta)
  'gl-ES', // Galician (Spain)
  'eu-ES', // Basque (Spain)
  'hy-AM', // Armenian (Armenia)
  'ky-KG', // Kyrgyz (Kyrgyzstan)
  'tk-TM', // Turkmen (Turkmenistan)
  'uz-UZ', // Uzbek (Uzbekistan)
  'qu-PE', // Quechua (Peru)
  'ay-BO', // Aymara (Bolivia)
  'ne-NP', // Nepali (Nepal)
  'bs-BA', // Bosnian (Bosnia and Herzegovina)
  'bs-BR', // Bosnian (Brazil)
  'su-ID', // Sundanese (Indonesia)
  'iw-IL', // Hebrew (Israel)
];



export const ORG_STATUS = [
  "DRAFT",
  "VERIFIED",
  "VERIFICATION_PENDING",
  "BLOCKED",
  "REJECTED"
]


export const MENU_LIST = [

  {
    label: 'Organizations',
    link: '/settings/org',
    icon: ["pi", "pi-building"],
    hidden: false,
    subMenu: [
      {
        label: 'Add Organization',
        link: '/settings/org/add',
        icon: 'add',
        hidden: true,
      },
      {
        label: 'View Organization',
        link: '/settings/org',
        icon: 'visibility',
        hidden: true,
      },
      // {
      //   label: 'Update Organization',
      //   link: 'org/update',
      //   icon: 'edit',
      //   hidden: true,
      // }
    ],
  },
  {
    label: 'Roles & Access',
    link: '/settings/roles',
    icon: ["pi", "pi-slack"],
    hidden: false,
    subMenu: [
      {
        label: 'Add Role',
        link: '/settings/roles/add',
        icon: 'add',
        hidden: true,
      },
      {
        label: 'View Role',
        link: '/settings/roles/view',
        icon: 'visibility',
        hidden: true,
      },
    ],
  },
  {
    label: 'Users',
    link: '/settings/users',
    icon: ["pi", "pi-users"],
    hidden: false,
    subMenu: [
      {
        label: 'Add User',
        link: '/settings/users/add',
        icon: 'add',
        hidden: true,
      },
      {
        label: 'View User',
        link: '/settings/users',
        icon: 'visibility',
        hidden: true,
      },
    ],
  },
];


export const HOME_TABS = [
  {
    icon: 'pi pi-home', label: 'Home',  routerLink:'/home', auth: 433
  },
  {
    icon: 'pi pi-list-check',  label: 'GST Reconciliation',  routerLink:'/gst-reconciliation' , auth: 431
  },
  {
    icon: 'pi pi-file-import',  label: 'Import Matching',  routerLink:'/import-matching' , auth: 437
  },
  {
    label: 'Settings', icon: 'pi pi-cog', routerLink:'/settings', auth: 131
  },
]
